<template>
  <b-card v-if="hideCard" body-class="d-flex flex-row d-flex flex-row justify-content-start align-items-center p-2">
    <font-awesome-icon class="mr-2" :icon="[ 'fab', 'linkedin' ]" size="lg"/>
    <template v-if="hasConnectedLinkedIn">
      <h6 class="m-0">{{ $t('campaign.scheduled-posts.description-schedule') }}</h6>
      <div class="flex-fill"/>
      <b-btn class="ml-1" v-b-modal="scheduleModalID" variant="linkedin">{{ $t('campaign.scheduled-posts.button-schedule') }}</b-btn>
    </template>
    <template v-else>
      <h6 class="m-0">{{ $t('campaign.scheduled-posts.description-connect') }}</h6>
      <div class="flex-fill"/>
      <b-btn class="ml-1" :href="connectLinkedInURL" variant="linkedin">{{ $t('campaign.scheduled-posts.button-connect') }}</b-btn>
    </template>
    <b-modal hide-footer :title="$t('campaign.scheduled-posts.title')" :id="scheduleModalID" lazy>
      <slot name="schedule-posts-modal"/>
    </b-modal>
  </b-card>
</template>

<script>
import qs from 'querystring';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    scheduleModalID: String,
  },
  computed: {
    ...mapRoot([ 'user', 'origin', 'authServiceOrigin', 'isInforma', 'isBallastNedam' ]),
    hideCard() {
      const { isInforma, isBallastNedam } = this;

      const hideFor = [ isInforma, isBallastNedam ];
      return !hideFor.some(c => c);
    },
    hasConnectedLinkedIn() {
      const { state } = this.user || {};
      const { linkedIn } = state || {};
      const { accessToken, expiresAt, version } = linkedIn || {};
      const now = new Date().getTime();
      return Boolean(accessToken && expiresAt && expiresAt > now && version !== 'v2');
    },
    connectLinkedInURL() {
      const { authServiceOrigin, origin } = this;
      const { path } = this.$route;

      const query = {
        scope: 'r_liteprofile r_emailaddress w_member_social',
        redirect: `${origin}${path}?callback=connectedLinkedInForScheduling`,
      };
      return `${authServiceOrigin}/oauth2/linkedin?${qs.stringify(query)}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/ScheduleLinkedInCard.vue